import { render, staticRenderFns } from "./ChatAI.vue?vue&type=template&id=51c577b7&scoped=true"
import script from "./ChatAI.vue?vue&type=script&lang=js"
export * from "./ChatAI.vue?vue&type=script&lang=js"
import style0 from "./ChatAI.vue?vue&type=style&index=0&id=51c577b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c577b7",
  null
  
)

export default component.exports